module.exports = __webpack_public_path__ + "img/logo_full.de29047d.png";